var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { handleToggleRecipeSelection_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/handleToggleRecipeSelection_V2";
import { openCustomizeModal_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/openCustomizeModal_V2";
export const handleSingleSelectClick = ({ openCustomizeModal, handleToggle, recipeHandlerProps_Three: RHP, assignmentCount, shouldOpenCustomizeModal, isProcessingChange, setIsProcessingChange, setIsCustomizeModalOpen, setDialogContentMode, setIsDetailDialogOpen, setOpenFromIncrement, companyUsesKlaviyo, createKlaviyoEvent, datadogLog, isSingleSelect, logReactPixel, reactPixelKey, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (isProcessingChange)
        return;
    setIsProcessingChange(true);
    const handleLegacy = () => {
        if (openCustomizeModal)
            openCustomizeModal();
        else if (handleToggle)
            handleToggle();
        setIsProcessingChange(false);
    };
    const handleV2 = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!RHP)
            return handleLegacy();
        try {
            if (shouldOpenCustomizeModal) {
                yield openCustomizeModal_V2({
                    assignmentCount: assignmentCount || 0,
                    companyUsesKlaviyo,
                    createKlaviyoEvent,
                    datadogLog,
                    isSingleSelect,
                    logReactPixel,
                    reactPixelKey,
                    recipeHandlerProps_Three: RHP,
                    setDialogContentMode,
                    setIsCustomizeModalOpen,
                    setIsDetailDialogOpen,
                    setOpenFromIncrement,
                });
            }
            else {
                yield handleToggleRecipeSelection_V2(Object.assign(Object.assign({}, RHP), { companyUsesKlaviyo,
                    createKlaviyoEvent,
                    datadogLog,
                    logReactPixel,
                    reactPixelKey }));
            }
        }
        finally {
            setIsProcessingChange(false);
        }
    });
    RHP ? yield handleV2() : handleLegacy();
});
